import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  email: string;
};

export const BrandEmailCell = ({ email }: Props) => {
  return <div className={desktopTruncateStyle}>{email}</div>;
};
